var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"cfb7f33b6a7dbb8fe53115235665ffa381ad9c35"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["lively-root@lively-root"]={id:"cfb7f33b6a7dbb8fe53115235665ffa381ad9c35"};
      